// In-app browsers (Instagram, TikTok, Facebook, etc.) are embedded webviews
// that block or silently break OAuth popups. For these we must use a full-page
// redirect instead of signInWithPopup — otherwise social-traffic users hit a
// dead button and bounce. Best-effort UA sniff; false negatives just keep the
// popup path (with its own popup-blocked → redirect fallback in firebase.ts).
//
// The Google app (UA token "GSA") must NOT be listed: its popup sign-in works,
// while the redirect never returns to the app (Google/Apple sign-in there fell
// from ~80% to ~8% / ~1% while it was on this list, Jul 9 – Oct 2026).
const IN_APP_BROWSER_UA = /FBAN|FBAV|FB_IAB|Instagram|Line\/|LinkedInApp|Twitter|TikTok|musical_ly|Snapchat|Pinterest|WhatsApp|WeChat|MicroMessenger/i;

export function isInAppBrowser(userAgent?: string): boolean {
  if (userAgent === undefined && typeof navigator === 'undefined') return false;
  const ua = userAgent ?? (navigator.userAgent || (navigator as unknown as { vendor?: string }).vendor || '');
  return IN_APP_BROWSER_UA.test(ua);
}
